import { TranscriptionService } from '@klangio/ai2notes-ts-client';
import { type TranscriptionDialogContextValue } from '../context/TranscriptionDialogContext/TranscriptionDialogContext';

export function getParameterByName(name: string, url?: string) {
  let newUrl = url;
  if (!url) newUrl = window.location.href;
  const newName = name.replace(/[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(newUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getDoubleTicketString(userTickets: number, subscriptionTickets: number) {
  return ` ${userTickets} | ${subscriptionTickets} `;
}

export function updateQueryStringParameter(name: string, value: string, url?: string) {
  let newUrl = url;
  if (!url) newUrl = window.location.href;
  const re = new RegExp(`([?&])${name}=.*?(&|$)`, 'i');
  const separator = newUrl?.indexOf('?') !== -1 ? '&' : '?';
  if (newUrl?.match(re)) {
    return newUrl.replace(re, `$1${name}=${value}$2`);
  }
  return `${newUrl + separator + name}=${value}`;
}

export function toMMSS(secNum: number) {
  let minutes: number | string = Math.floor(secNum / 60);
  let seconds: number | string = Math.floor(secNum - minutes * 60);

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${minutes}:${seconds}`;
}

export function scrollToSection(id: string) {
  setTimeout(() => {
    const yOffset = -200;
    const elem = document.getElementById(id);
    if (elem) {
      const { top } = elem.getBoundingClientRect();
      const y = window.pageYOffset + yOffset + top;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, 100);
}

export function generateRandomColorByString(text: string) {
  let value = 0;
  const colors = ['107fb4', '82ab5a', 'f4d700', 'e68911', 'd73a22'];

  /* eslint-disable no-bitwise */
  for (let i = 0; i < text.length; i += 1) {
    value = text.charCodeAt(i) + ((value << 5) - value);
  }

  value %= colors.length;
  return `#${colors[value]}`;
}

export const replaceStringifiedNullValueParameters = (
  parameters:
    | TranscriptionDialogContextValue['apriori']
    | TranscriptionDialogContextValue['settings']
) => {
  const params: any = { ...parameters };
  Object.keys(params).forEach((key) => {
    if (params[key as keyof typeof params] === 'null') {
      params[key as keyof typeof params] = null;
    }
  });
  return params;
};

export const safeJSONParse = (json: string) => {
  try {
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

const STORAGE_ITEM = 'transcriptionIds';

export const storeTranscriptionIdFromUnkownUsers = (id: string) => {
  const ids = JSON.parse(localStorage.getItem(STORAGE_ITEM) ?? '[]') || [];
  if (!ids.some((item: string) => item === id)) {
    ids.push(id);
  }
  localStorage.setItem(STORAGE_ITEM, JSON.stringify(ids));
};

export const addStoredTranscriptionIdsToUser = () => {
  const ids = JSON.parse(localStorage.getItem(STORAGE_ITEM) ?? '[]');

  if (JSON.parse(localStorage.getItem(STORAGE_ITEM) ?? '[]')?.length > 0) {
    const promises = ids.map((id: string) =>
      TranscriptionService.transcriptionClaimTranscription(id)
    );

    Promise.all(promises)
      .then(() => {
        localStorage.removeItem(STORAGE_ITEM);
      })
      .catch((e) => {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem(STORAGE_ITEM);
        }
      });
  }
};

export function parseJwt(token: string) {
  const base64Url = token?.split('.')?.[1];
  const base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
  if (base64) {
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => {
          return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }
  return null;
}

export const isJwtTokenStringValid = (token: string) => {
  const jwt = parseJwt(token);
  return jwt && jwt.exp * 1000 > Date.now();
};

export const isJwtTokenValid = () => {
  const token = JSON.parse(window.localStorage?.getItem('currentUser') ?? '{}')?.token;
  return isJwtTokenStringValid(token);
};
